import { html, LitElement, css, unsafeCSS } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import { isTouchDevice } from '../shared/utils';

import '../components/discorduser';

import style from './buildlist.scss';

export class BuildListComponent extends LitElement {

    static get properties() {
        return {
            data: Array,
            title: String,
            url: String,
            inline: Boolean,
            autohide: Boolean           
        }
     }

    constructor() {
        super();
        this.data = [];
        this.url = '';
        this.inline = false;
        this.title = 'Builds';
        this.autohide = false;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();        
        this.fetchData();
    }

    async fetchData() {                        
        let res = await fetch(`./api/${this.url}`);
        this.data = await res.json();        
    }
   
    render() {
        if(this.autohide && this.data.length === 0)
            return html`${this.inline?html`<br>`:''}`;            
        return html`     
            ${!this.inline?html`<h3 class="title">${this.title}</h3>`:''}      
            <div class="builds">
            ${this.data.map(build=>{                
                return html`<div class="line" style=";${this.inline?'display:inline-block;padding:2px 5px':''}">
                    <a class="class-${build.class.replace('[','').replace(']','').toLowerCase()}" href="./build/${build.uid}">
                    <card-part id=${build.artwork} imageonly="true" header=${isTouchDevice()&&!this.inline?'true':''}
                    style="${isTouchDevice()&&!this.inline?`position: absolute;right: 10px;top: 2px;`:''}"></card-part> <span class="build-name">${build.name}</span>
                    </a> 
                    ${!this.inline?html`            
                        ${isTouchDevice()?html`<br>`:html`&nbsp;&nbsp;`}            
                        <discorduser-component user=${build.discorduser}></discorduser-component>        
                        ${isTouchDevice()?html`<br><br>`:''}                
                    `:''}                    
                </div>`;
            })}    
            </div>
        `;
    }
}

customElements.define('buildlist-component', BuildListComponent);